//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "tagExtend",
  components: {},
  props: {
    size: {
      type: String,
      default: function _default() {
        return "medium";
      } // medium / small / mini
    },
    type: {
      type: String,
      default: function _default() {
        return "";
      } // success / info / warning / danger / purple
    },
    hit: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    dataList: {
      handler: function handler(v, o) {},
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {}
};